// extracted by mini-css-extract-plugin
export default {"qtyField":"completeShipmentItemsTable_qtyField__qN8ww"};